import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../../../api/store/commonSlice";
import { useTranslation } from "react-i18next";
import FTModal from "../../../../components/common/FTModal";
import {
  AdminFormFieldInput,
  AdminFormFieldSubmit,
} from "../../../../components/admin/formFields";
import { toast } from "react-toastify";
import { TLegacyVehicle } from "../../../../api/types/Vehicle";
import { Dispatch, SetStateAction } from "react";
import { FormikProps } from "formik";

type ModalAssetDecodeVINProps = {
  decodeVinData?: {
    make: string;
    model: string;
    modelyear: string;
  };
  dataSingleVehicle: TLegacyVehicle | undefined;
  setDecodeVinData: Dispatch<
    SetStateAction<{
      make: string;
      model: string;
      modelyear: string;
    }>
  >;
  formik: FormikProps<any>;
};
const ModalAssetDecodeVIN = ({
  decodeVinData,
  dataSingleVehicle,
  setDecodeVinData,
  formik,
}: ModalAssetDecodeVINProps) => {
  const { t: tMain } = useTranslation();
  const { t } = useTranslation("translation", {
    keyPrefix: "admins.vehicles.detailsPage.form",
  });
  const modalsState = useSelector(
    (state: { commonReducer: { modals: TModalsState } }) =>
      state.commonReducer.modals
  );
  const dispatch = useDispatch();

  const hideModal = () => {
    setDecodeVinData?.({
      make: "",
      model: "",
      modelyear: "",
    });
    dispatch(setModalsData({ ...modalsState, showModalAssetDecodeVIN: false }));
  };

  const handleConfirm = () => {
    // Apply decoded values to the form fields instead of saving directly to the backend.
    // This ensures that all pending edits (description, display name, group membership, etc.)
    // are preserved and everything gets saved together when the user clicks Save.
    formik.setFieldValue("vehicle_make", decodeVinData?.make || "");
    formik.setFieldValue("vehicle_model", decodeVinData?.model || "");
    formik.setFieldValue(
      "vehicle_year",
      decodeVinData?.modelyear ? parseInt(decodeVinData.modelyear) : null
    );
    toast.success("VIN decoded — Make, Model, and Year applied to form. Save the asset to persist changes.");
    hideModal();
    setDecodeVinData?.({
      make: "",
      model: "",
      modelyear: "",
    });
  };

  return (
    <FTModal
      visible={modalsState.showModalAssetDecodeVIN}
      heading={t("heading")}
      onHide={hideModal}
      dismissible={true}
      containerStyle="max-w-[calc(100vw-4rem)] w-[560px]"
      position="center"
    >
      <div className="grid grid-cols-6 gap-6">
        <p className="col-span-6 mt-0 leading-relaxed text-gray-500">
          {t("sub_heading")}
        </p>

        <AdminFormFieldInput
          label={t("make")}
          type="text"
          id="make"
          name="make"
          readOnly={true}
          value={decodeVinData?.make}
        />
        <AdminFormFieldInput
          label={t("model")}
          type="text"
          id="model"
          name="model"
          readOnly={true}
          value={decodeVinData?.model}
        />
        <AdminFormFieldInput
          label={t("year")}
          type="text"
          id="year"
          name="year"
          readOnly={true}
          value={decodeVinData?.modelyear}
        />

        <AdminFormFieldSubmit
          label={t("update_asset")}
          variant="primary"
          disabled={
            !decodeVinData?.make ||
            !decodeVinData?.model ||
            !decodeVinData?.modelyear
          }
          onClick={handleConfirm}
        />

        <AdminFormFieldSubmit
          label={tMain("cancel")}
          type="button"
          variant="danger-transparent"
          onClick={hideModal}
        />
      </div>
    </FTModal>
  );
};
export default ModalAssetDecodeVIN;
